// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2GBAP","label":"Section_label__3eGdQ","contentWrap":"Section_contentWrap__2HBuG","footer":"Section_footer__3nn55","footerInner":"Section_footerInner__1jKSe"};